import React, { useState, Fragment } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import LinkButton from "../../utils/LinkButton";
import useOnceEffect from "../../Hooks/useOnceEffect";
import { CerrarVacanteModal, VacantesCerradas } from "../Company/EstadoVacantes";
import useToggle from "../../Hooks/useToggle";
import CustomSwitch from "../../utils/Switch/Switch";

function EstadoVacantes({ data }) {
  const [listVacantes, setlistVacantes] = useState([]);
  const [vacanteId, setVacantId] = useState(null)
  const [modal, toggleModal] = useToggle(false)
  const [showActiveVacant, setShowActiveVacant] = useState(true);

  useOnceEffect(() => {
    GetVacantes();
  });

  function GetVacantes() {

    axios
      .get("company-vacant/list-vacants/" + data.companyProfileId)
      .then((result) => {
        setlistVacantes(result.data);
      });
  }

  function SetTab() {
    document.getElementById("pills-tab3").setAttribute("class", "nav-link");
    document
      .getElementById("pills-tab1")
      .setAttribute("class", "nav-link active");
  }
 
  function CerrarVacante(body = {}) {

    axios
      .post(`company-vacant/close/${vacanteId}`, body)
      .then((result) => {
        if (result.status === 200) {
          toast.success(result.data.message, {
            duration: 4000,
          });
          GetVacantes();
        }
      })
      .finally(() => toggleModal())
  }
  return (
    <Fragment>
      <div className="content">
        <div className="row mt-5">
          
          <section className="d-flex justify-content-between align-items-center">
            <h5>Vacantes y Pasantías Publicadas</h5>

            
            <CustomSwitch label="Vacantes activas" onchange={setShowActiveVacant} />
          </section>

          <hr />

          <p className="mt-4">Personaliza el estado de vacante</p>
          
          <br />
          <br />

          { showActiveVacant  && <Vacantes {...{listVacantes, SetTab, toggleModal, setVacantId}} /> }
          { !showActiveVacant && <VacantesCerradas companyId={data?.companyProfileId} /> }

        </div>
      </div>

      <div
        id="cerrar-vacante-modal"
        className="kr-modal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title"></div>

              <div
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="close"
              >
                <span aria-hidden="true">&times;</span>
              </div>
            </div>

            <div className="modal-body">
              <div className="form form--white">
                <div className="div__wrapper">
                  <div className="form__title text-center">
                    ¿Estas seguro que deseas cerrar la Vacante?
                  </div>
                  <div className="form__row">
                    <div className="col-sm-12 ">
                      <label htmlFor="names">
                        {" "}
                        Nota:Al cerrar la vacante,ya no podras recibir mas
                        pustulaciones de esta Vacante
                      </label>
                    </div>
                  </div>
                  <div className="form__row mt-5">
                    <div
                      data-dismiss="modal"
                      className="btn btn--gradient btn__icon btn__icon--door"
                    >
                      {" "}
                      Cancelar
                    </div>
                    <div
                      className="btn btn--gradient btn__icon btn__icon--door"
                      onClick={() => CerrarVacante()}
                    >
                      Cerrar Vacante
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CerrarVacanteModal show={modal} onHide={toggleModal} CerrarVacante={CerrarVacante} vacantId={vacanteId}  />
    </Fragment>
  );
}


function Vacantes({listVacantes = [], SetTab, toggleModal, setVacantId}) {

  if(listVacantes.length === 0) {
    return <h2 className="text-center">No hay Vacantes Abiertas todavía</h2>
  }

  return listVacantes.map((item, index) => (
      <div key={index} className="col-md-12">
        <div className="steps-box mb-4">
          <div className="row">
            <div className="col-md-6">
              <p className="tit">{item.companyDTOResponse.cargo}</p>
            </div>
            <div className="col-md-6 text-end">
              <p className="sub-tit">
                Fecha de Publicación:{" "}
                <span>{item.companyDTOResponse.fechaPublicacion}</span>
              </p>
              <p className="sub-tit">
                Estado:{" "}
                <span>
                  {item.companyDTOResponse.esVigente
                    ? "Activo"
                    : "Cerrada"}
                </span>
              </p>
            </div>
          </div>
          <div className="process-wrapper mb-3">
            <div id="progress-bar-container">
              <ul>
                {item.etapasVacante.map((item, index) => {
                  return (
                    <li
                      key={index}
                      className={
                        item.completado
                          ? "step stepA" + item.orden + " active"
                          : "step stepA" + item.orden
                      }
                    >
                      <div className="step-inner">
                        {item.nombreEtapa}
                      </div>
                    </li>
                  );
                })}
                {/* 
              <li className="step stepA7">
                <div className="step-inner">Agregar Etapa</div>
              </li> */}
              </ul>
              <div id="line">
                <div id="line-progress"></div>
              </div>
            </div>
          </div>
          <div className="row mt-3 justify-content-end">
            <LinkButton
              to={{
                pathname: "/CentroFormacion/Vacante/Publica",
                state: {
                  vacantId: item.companyDTOResponse.companyVacantId,
                },
              }}
              onClick={SetTab}
              type="button"
              className="btn btn-infome-4 btn btn-light"
              style={{ marginRight: "24px", borderRadius: "30px" }}
            >
              Editar
            </LinkButton>
            <button
              className="me-4 btn btn-light"
              onClick={() => {
                toggleModal()
                setVacantId(item.companyDTOResponse.companyVacantId)
              }}
              style={{ borderRadius: "30px" }}
            >
              Cerrar Vacante
            </button>

            <LinkButton
              to={{
                pathname: "/CentroFormacion/Vacante/Candidatos",
                state: {
                  vacante: item.companyDTOResponse,
                  etapas: item.etapasVacante,
                },
              }}
              // onClick={SetTab}
              type="button"
              className="btn btn-info"
              style={{ height: "50px", width: "auto" }}
            >
              Ver Candidatos
            </LinkButton>
          </div>
        </div>
      </div>
  ))


}

export default EstadoVacantes;
